import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface EnrollPayload {
  taxId: string;
  name: string;
  countryId: number;
  address: string;
  comunneId: number;
  email?: string;
  phoneNumber?: string;
  adminEmail: string;
  adminFirstName: string;
  adminLastName: string;
  adminPassword: string;
}

export interface EnrollResponse {
  business: { uuid: string; name: string; enabled: boolean };
  adminUserId: string;
}

@Injectable({ providedIn: 'root' })
export class EnrollService {
  private baseUrl = 'http://localhost:3000/api/v1/auth';
  private http: HttpClient; // Client sin interceptores

  constructor(handler: HttpBackend) {
    // Usar HttpBackend para evitar interceptores (no enviar token)
    this.http = new HttpClient(handler);
  }

  enroll(payload: EnrollPayload): Observable<EnrollResponse> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<EnrollResponse>(`${this.baseUrl}/enroll`, payload, { headers }).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 409) {
          const detail = typeof err.error === 'string' ? err.error : (err.error?.message || '');
          return throwError(() => new Error(`El RUT/taxId ya existe. ${detail ? 'Detalle: ' + detail : ''}`));
        }
        const msg = typeof err.error === 'string' ? err.error : (err.error?.message || err.message);
        return throwError(() => new Error(msg || 'Error desconocido'));
      })
    );
  }
}